import { useCallback } from 'react'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function useViewMode() {
  const { viewMode } = useSharedBrowserStateContext()
  const dispatch = useSharedBrowserDispatchContext()

  const setViewMode = useCallback(
    (newViewMode) => {
      dispatch({ type: 'SET_VIEW_MODE', value: newViewMode })
    },
    [dispatch]
  )

  return { viewMode, setViewMode }
}
